<template>
  <div>
    <dl>
      <dt @click="change">
        <p class="img">
          <img :src="drawer ? cartOpen : cartClose" />
          <span>{{ amountSum }}</span>
        </p>
        <div class="price" v-if="!disabled">
          <p class="light-price">
            {{ cartData.prices && cartData.prices.itemFavorPriceDisplay }}
          </p>
          <p
            class="hide-price"
            v-if="
              Number(cartData.prices.itemFavorPrice) !==
              Number(cartData.prices.itemTotalPrice)
            "
          >
            {{ cartData.prices && cartData.prices.itemTotalPriceDisplay }}
          </p>
        </div>
        <div
          class="price-loading"
          v-show="disabled"
          v-r-loading="disabled"
          fe-hide-container="true"
        ></div>
      </dt>
      <dd>
        <el-button :disabled="disabled || isClose" @click="check">{{
          $t('去结算')
        }}</el-button>
      </dd>
    </dl>
  </div>
</template>

<script>
import cartOpen from '@/assets/images/didi/cartOpen.png';
import cartClose from '@/assets/images/didi/cartClose.png';
export default {
  data() {
    return {
      cartOpen: cartOpen,
      cartClose: cartClose,
    };
  },
  props: {
    cartData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
    drawer: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    amountSum() {
      let amountArr = [];
      this.cartData?.items?.forEach((item) => {
        amountArr.push(item.amount);
      });
      return amountArr.reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
    },
  },
  methods: {
    change() {
      if (!this.disabled) this.$emit('change');
    },
    check() {
      this.$trackEvent({
        eventId: 'sailing_c_x_cart_minicart_checkout_ck',
        eventLabel: 'mini购物车中点击去结算',
        attrs: {
          shop_id: this.cartData?.shopId,
          cart_id: this.cartData?.cartId,
        },
      });
      this.$emit('check');
    },
  },
};
</script>
<style lang="scss" scoped>
dl {
  display: flex;
  padding: 10px 15px 10px 6px;
  height: 72px;
  box-sizing: border-box;
  align-items: center;
  background: #fff;
  dt {
    flex: 1;
    display: flex;
    align-items: center;
    .img {
      position: relative;
      width: 60px;
      height: 60px;
      cursor: pointer;
      img {
        width: 60px;
        height: 60px;
        display: block;
      }
      span {
        position: absolute;
        width: 22px;
        height: 18px;
        background: #ee1a1a;
        border: 1.5px solid #ffffff;
        border-radius: 9px;
        font-family: 'Aspira Medium';
        font-size: 13px;
        display: inline-block;
        text-align: center;
        line-height: 14px;
        color: #fff;
        right: 0;
        top: 5px;
      }
    }
    .price {
      flex: 1;
      margin-left: 10px;
      .light-price {
        font-family: 'Aspira Medium';
        font-weight: 500;
        font-size: 18px;
      }
      .hide-price {
        font-family: 'Aspira Light';
        font-weight: 200;
        font-size: 12px;
        color: #999999;
        margin-top: 5px;
        text-decoration: line-through;
      }
    }
    .price-loading {
      flex: 1;
      left: -50px;
      svg {
        width: 30px;
      }
    }
  }
  dd {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      padding: 12px;
      height: 48px;
      min-width: 126px;
      font-family: 'Aspira Medium';
    }
  }
}
@media screen and (max-width: 768px) {
  dl {
    padding: rem(24) rem(42) rem(60) rem(20);
    height: rem(176);
    dt {
      .img {
        width: rem(128);
        height: rem(128);
        img {
          width: rem(128);
          height: rem(128);
        }
        span {
          width: rem(44);
          height: rem(36);
          border-radius: rem(18);
          font-size: rem(26);
          line-height: rem(30);
          top: rem(10);
        }
      }
      .price {
        margin-left: rem(20);
        .light-price {
          font-size: rem(36);
        }
        .hide-price {
          font-size: rem(24);
          margin-top: rem(10);
        }
      }
    }
    dd {
      top: rem(-14);
      .el-button {
        padding: rem(24);
        font-size: rem(32);
        width: rem(255);
        height: rem(92);
      }
    }
  }
}
</style>